import { Component } from '@angular/core';
import { BaseRow } from '../base-row';

@Component({
    selector: 'app-supplier-invoice-row',
    templateUrl: './supplier-invoice-row.component.html',
    styleUrls: ['./../base-row.component.scss'],
    standalone: false
})
export class SupplierInvoiceRowComponent extends BaseRow {
}
